/**
 * Media Component generates either a <img> if given no children or a GatsbyImage if given
 * children. The component then generates a responsive image and banner.
 */

import React from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import '../styles/index.scss';
var defaultProps = {
  children: null,
  caption: '',
  brand: 'law',
  src: ''
};

/**
 * Generates the image
 * @param  {GatsbyImage} children - Used to generate a GatsbyImage if Gatsby is available
 * @param  {String} alt
 * @param  {String} src
 * @param  {String} caption - The text that appears in the caption
 * @param  {String} brand - assigns the brand being used
 */
var Media = function Media(_ref) {
  var children = _ref.children,
    alt = _ref.alt,
    src = _ref.src,
    caption = _ref.caption,
    brand = _ref.brand;
  return /*#__PURE__*/React.createElement(Container, {
    fluid: true,
    className: "p-0 imageWrapper " + brand + " cms"
  }, children || /*#__PURE__*/React.createElement("img", {
    className: "image",
    alt: alt,
    src: src
  }), caption && /*#__PURE__*/React.createElement(Row, {
    className: "m-0"
  }, /*#__PURE__*/React.createElement(Col, {
    xs: 10,
    className: "p-0"
  }, /*#__PURE__*/React.createElement("h5", {
    "data-testid": "caption",
    className: "caption"
  }, caption))));
};
Media.defaultProps = defaultProps;
export { Media };